import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormSelectModelDto } from "../../../payment-link-list/models/paylinks.model";
import { CheckItem } from "../../../../components/checkbox-block/checkbox-block.component";
import { VirtualCashModelsDto } from "../../models/virtual-cash.models";
import { Subscription, takeUntil } from "rxjs";
import { ModalService } from "../../../../services/modal.service";
import { VirtualCashDataService } from "../../services/virtual-cash-data.service";
import { UnsubscribeService } from "src/app/services/unsubscribe.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TerminalsListDto } from "src/app/pages/terminal-list/models/terminal.models";
import { Router } from "@angular/router";

@Component({
  selector: "app-edit-virtual-cash-dialog",
  templateUrl: "./edit-virtual-cash-dialog.component.html",
  styleUrls: ["./edit-virtual-cash-dialog.component.scss"],
  providers: [UnsubscribeService],
})
export class EditVirtualCashDialogComponent implements OnInit {
  @Input() currenciesList: FormSelectModelDto[] = [];
  @Input() detailVirtualCash$!: Subscription;
  @Input() selectedVirtualPosId: number | null = null;
  @Output() updateCashEvent: EventEmitter<number> = new EventEmitter<number>();

  form!: FormGroup;

  bankList: FormSelectModelDto[] = [];

  isP2p: CheckItem = { name: "P2P_OPERATION_CASH", state: false, id: 2 };

  selectedTerminal: number | null = null;

  isOpenCurrencySelect = false;
  selectedCurrency: string[] = [];

  isTerminalsBlockOpen = true;
  selectedTerminals: any[] = [];
  terminalList: TerminalsListDto | null = null;
  loadingData: VirtualCashModelsDto | null = null;
  isSending = false;

  constructor(
    private modalService: ModalService,
    private virtualCashDataService: VirtualCashDataService,
    private unsubscribe$: UnsubscribeService,
    public router: Router
  ) {}

  ngOnInit() {
    this.initData();
    this.initForm();
    this.initModal();
  }

  initForm() {
    this.form = new FormGroup({
      terminalName: new FormControl("", [Validators.required]),
      commission: new FormControl("", [Validators.max(100), Validators.required]),
    });
  }

  initModal() {
    this.modalService.isModalOpen$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (res) => {
        if (!res) {
          this.form.reset();
        }
      },
    });
  }

  initData() {
    this.virtualCashDataService
      .loadDetailVirtualCash(this.selectedVirtualPosId!)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res) => {
          this.loadingData = res;

          this.isP2p.state = res.is_for_p2p;

          this.selectedTerminals = res.terminals!.sort((a: any, b: any) => a.bank_id - b.bank_id);

          this.form.patchValue({ terminalName: res.virtual_pos_name });
          this.form.patchValue({ commission: res.commission });
        },
      });
  }

  closeModal() {
    this.modalService.closeModal();
  }

  sendForm() {
    this.isSending = true;
    const result: any = {
      terminalIdList: this.selectedTerminals.map((item) => item.id),
      virtual_pos_name: this.form.get("terminalName")?.value,
      min_amount: this.loadingData!.min_amount,
      max_amount: this.loadingData!.max_amount,
      commission: !this.loadingData?.is_for_p2p ? this.form.get("commission")?.value || 0 : 0,

      currency: this.selectedCurrency.join(),
      is_blocked: this.loadingData!.is_blocked,
      is_for_p2p: this.loadingData!.is_for_p2p,
      is_aft: this.loadingData!.is_aft,
    };

    this.virtualCashDataService.updateVirtualCash(this.loadingData!.id, result).subscribe({
      next: () => {
        this.isSending = false;
        this.modalService.closeModal();
        this.updateCashEvent.emit(this.loadingData?.id);
      },
      error: () => {
        this.isSending = false;
      },
    });
  }

  get terminalNameRequireError() {
    return this.form.get("terminalName")?.hasError("required");
  }

  get commissionMaxError() {
    return this.form.get("commission")?.hasError("max");
  }

  get commissionRequireError() {
    return this.form.get("commission")?.hasError("required");
  }
}
